export const UAT_WS_URL = 'http://npasimulcastwsuat.npauctions.com';
export const UAT_API_URL = 'http://npasimulcastapiuat.npauctions.com';
export const DEV_WS_URL = 'http://npasimulcastwsstage.npauctions.com';
export const DEV_API_URL = 'http://npasimulcastapistage.npauctions.com';
export const SIM_HUB_ENDPOINT = '/SimulcastHub';
export const ENDPOINT_TYPE = {
  WebSocket: 'ws',
  Api: 'api',
};
export const UAT_WS_HUB_ENDPOINT = `${UAT_WS_URL}${SIM_HUB_ENDPOINT}`;
export const UAT_API_HUB_ENDPOINT = `${UAT_API_URL}${SIM_HUB_ENDPOINT}`;
export const DEV_WS_HUB_ENDPOINT = `${DEV_WS_URL}${SIM_HUB_ENDPOINT}`;
export const DEV_API_HUB_ENDPOINT = `${DEV_API_URL}${SIM_HUB_ENDPOINT}`;

export const EST_MINUTES_PER_AUCTION_ITEM = 0.5;

export const SOCKET_ERR_MSG = 'A host is required to establish a socket connection';

export const LCLSTRG_AUCTIONID_SUFFIX = '_auctionId';
export const LCLSTRG_LANEID_SUFFIX = '_auctionLaneId';
export const GOOGLE_ANALYTICS_KEY = 'G-81S2QRJQGT';
export const LONGEST_VIN_LENGTH = 17;